export class ScoreValue {
    itemId: string;
    studentId: string;
    value: string;
}